import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson } from '../../output.js'

export const servicesGetSecretCommand = new Command(`get-secret`)
  .description(`Show service connection credentials`)
  .argument(`<id>`, `Service ID`)
  .action(async (serviceId: string) => {
    const json = servicesGetSecretCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.services.getSecret({ serviceId })

      if (isQuiet()) {
        printQuiet(result.secret)
        return
      }

      if (json) {
        printJson(result)
      } else {
        process.stdout.write(result.secret + `\n`)
      }
    } catch (error) {
      handleError(error, json)
    }
  })
